import { useEffect, useState } from "react";
import { makeRequest } from "../../../assets/functions_helper";
import {
  Box,
  FormControlLabel,
  CircularProgress,
  Snackbar,
  Alert,
} from "@mui/material";
import SelectMoveData from "../../../components/selectMoveData";
import { useNavigate } from "react-router-dom";
import { CustomSwitch, NoSuggestionsTextField } from "../../../components/textFields";

function DetailUser({
  userId,
  user,
  setUser,
  roles,
  setRoles,
  selectedRoles,
  setSelectedRoles,
}) {
  const [isLoaded, setIsLoaded] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("error");
  const navigate = useNavigate();

  useEffect(() => {
    makeRequest(
      "GET",
      "users/" + userId,
      null,
      "application/json",
      localStorage.getItem("token"),
      localStorage.getItem("tokenType"),
      null,
      null,
      () => {
        navigate("/login");
      }
    )
      .then((response) => {
        const currentUpdatedResponse = response.roles.map((item) => ({
          ...item,
          title: item.name_es,
        }));

        setUser({
          name: response.name,
          last_name: response.last_name,
          email: response.email,
          lastLogin: response.last_login,
          is_active: response.is_active,
          roles: currentUpdatedResponse,
        });

        makeRequest(
          "GET",
          "users/roles",
          null,
          "application/json",
          localStorage.getItem("token"),
          localStorage.getItem("tokenType"),
          null,
          null,
          () => {
            navigate("/login");
          }
        )
          .then((response) => {
            const updatedResponse = response.map((item) => ({
              ...item,
              title: item.name_es,
            }));
            console.log(updatedResponse);

            setRoles(updatedResponse);

            setIsLoaded(true);
          })
          .catch((error) => {
            setSnackbarMessage(`Ocurrio un error al obtener los roles`);
            setSnackbarSeverity("error");
            setSnackbarOpen(true);
          });
      })
      .catch((error) => {
        setSnackbarMessage(`Ocurrio un error al obtener el usuario`);
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      });
  }, [userId, setRoles, setUser, navigate]);

  const handleChange = (event) => {
    setUser({
      ...user,
      [event.target.name]: event.target.value,
    });
  };

  const handleSwitchChange = (event) => {
    setUser({
      ...user,
      [event.target.name]: event.target.checked,
    });
  };

  return (
    <>
      {isLoaded ? (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center"
          }}
        >
          <NoSuggestionsTextField
            autoFocus
            required
            margin="dense"
            id="name"
            name="name"
            label="Nombre"
            type="text"
            fullWidth
            value={user.name}
            onChange={handleChange}
          />

          <NoSuggestionsTextField
            autoFocus
            required
            margin="dense"
            id="lastName"
            name="lastName"
            label="Apellido"
            type="text"
            fullWidth
            value={user.last_name}
            onChange={handleChange}
          />

          <NoSuggestionsTextField
            autoFocus
            required
            margin="dense"
            id="correo"
            name="email"
            label="Correo"
            type="email"
            fullWidth
            value={user.email}
            onChange={handleChange}
          />

          <FormControlLabel
            control={
              <CustomSwitch
                checked={user.is_active}
                name="is_active"
                onChange={handleSwitchChange}
              />
            }
            label="Activo"
          />
          <h3>Roles</h3>
          <SelectMoveData
            items={roles}
            currentItems={user.roles}
            selectedRoles={selectedRoles}
            setSelectedRoles={setSelectedRoles}
          />
        </Box>
      ) : (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "300px",
          }}
        >
          <CircularProgress />
        </Box>
      )}

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbarOpen(false)}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
}

export default DetailUser;
